import { ICustomer } from '../store/ducks/customers/types';

export const COMMERCE_CUSTOMER_TYPES = ['DI', 'IN', 'CC'];

export const Z002_CUSTOMER_TYPE = 'Z002';
export const SHIP_TO_BP_TYPE = 'shipTo';

export const filterInvalidCustomers = (
  customers: ICustomer[],
  enableBpTypeFilter: boolean
): ICustomer[] =>
  customers.filter(
    (c) =>
      !enableBpTypeFilter ||
      (c.customerType !== Z002_CUSTOMER_TYPE &&
        !!c.bpType &&
        c.bpType !== SHIP_TO_BP_TYPE)
  );

export const hasOnlyCGCustomerTypes = (customers: ICustomer[]): boolean =>
  customers.length > 0 &&
  customers.every((customer) => customer?.customerType === 'CG');

export const hasCommerceCustomerType = (customers: ICustomer[]): boolean =>
  customers.some((customer) =>
    COMMERCE_CUSTOMER_TYPES.includes(customer?.customerType ?? '')
  );

export const resolveIsCommerceUser = (
  journeyViews: string[] | undefined,
  customers: ICustomer[],
  migrationFlag: boolean
): boolean => {
  if (journeyViews?.includes('commerce_magento')) {
    return true;
  }

  if (hasCommerceCustomerType(customers)) {
    return Boolean(migrationFlag);
  }

  return false;
};
